import Image from '@space-core/components/image'
import styled, { css } from 'styled-components'

export const LogoHighlight = styled.div`
  position: absolute;
  right: -0.188rem;
  z-index: 11;
`

export const LogoContainer = styled('div')<{
  $isPreview?: boolean
  $showHeaderHighlight?: boolean
}>`
  ${({ $isPreview, $showHeaderHighlight }) =>
    $isPreview &&
    $showHeaderHighlight &&
    css`
      border: solid 0.188rem var(--blue);
      border-radius: 0.25rem 0.25rem 0 0.25rem;
    `}
`

export const LogoImage = styled(Image)`
  width: 100%;
  height: auto;
  padding-right: var(--spacer-5);
`

LogoHighlight.displayName = 'LogoHighlight'
LogoContainer.displayName = 'LogoContainer'
LogoImage.displayName = 'LogoImage'
